import {
  GET_ORDER_REVIEW_REQUEST,
  GET_ORDER_REVIEW_RESPONSE,
} from "./actionTypes";

export const getOrderReviewRequest = (orderId) => {
  return {
    type: GET_ORDER_REVIEW_REQUEST,
    payload: { orderId },
  };
};

export const getOrderReviewResponse = (apiResponse) => {
  return {
    type: GET_ORDER_REVIEW_RESPONSE,
    payload: { apiResponse },
  };
};
